import React, { useState, useEffect } from "react";
import ShowImageModel from "../modal/ShowImageModel";
import Modal from "../modal/Modal";

const Documents = ({ documents_data, initialState, setDocument }) => {
  const [docs, setDocs] = useState(initialState);

  const [imgLink, setImgLink] = useState("");

  useEffect(() => {
    // console.log('docs',docs)
    setDocument(docs);
  }, [docs]);

  const handleChange = async (e, item, index) => {
    let arr = [...docs];
    // console.log(arr);
    arr[index]["document_name"] = item.ip1;

    setDocs(arr);

    let reader = new FileReader();
    let baseURL = "";
    reader.readAsDataURL(e.target.files[0]);
    // on reader load somthing...
    return new Promise((resolve) => {
      reader.onload = () => {
        // Make a fileInfo Object
        // console.log("Called", reader);
        baseURL = reader.result;
        // baseURL = baseURL.slice(5,baseURL.length)
        // baseURL += "="
        arr[index].image = baseURL;

        resolve(baseURL);
      };
    });
  };

  useEffect(() => {
    // console.log(
    //   initialState)
  });

  // console.log(documents_data)

  return (
    <div className="overflow-x-scroll">
      <table className="w-full border-2 border-primary-blue">
        <thead>
          <tr className="border-b-2 border-primary-blue">
            <td className="border-primary-blue text-primary-red border p-2 text-lg font-bold">
             S.N
            </td>
            <td className="border-primary-blue text-primary-red border md:px-20 text-base font-bold sm:text-lg">
              Document Names
            </td>
            <td className="border-primary-blue text-primary-red border md:px-20 text-base font-bold sm:text-lg">
              Action
            </td>
            <td className="border-primary-blue text-primary-red border md:px-20 text-base font-bold sm:text-lg">
              Remarks
            </td>
          </tr>
        </thead>

        <tbody>
          {documents_data.map((item, index) => {
            // console.log(index)
            return (
              <tr className="border-primary-blue border" key={index}>
                {/* {setDocs((docs) => ([ ...docs, initialState]))} */}

                <td className="text-primary-red border-primary-blue border-r  text-center font-semibold">
                  {index + 1}
                </td>
                <td className="   flex flex-wrap">
                  <p className="border-primary-blue flex font-Laila text-primary-blue font-semibold m-0  w-full  md:first-line:p-3 outline-none">
                    {item.ip1}
                  </p>
                  {/* <button className="bg-primary-blue text-white rounded-xl ml-3 px-2">
                        Upload
                      </button> */}
                  <input
                    className="file:bg-primary-blue w-[50%] outline-none file:text-white file:border-0 file:rounded-xl file:text-sm  text-white rounded-xl "
                    type="file"
                    onChange={async (e) => {
                      handleChange(e, item, index);
                    }}
                  />
                </td>
                <td className="border-l border-blue-600">
                  <div className="flex justify-center flex-wrap gap-2 ">
                    <div
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModalPreview"
                      // className="bg-primary-blue mx-auto grid w-fit place-content-center rounded-full px-5 py-2 text-center text-xl font-bold text-white"
                    >
                      <input
                        type="button"
                        className="bg-primary-green text-white rounded-xl px-2 "
                        value="View"
                        onClick={() => {
                          setImgLink(
                            docs[index].image === "" ? "" : docs[index].image
                          );
                        }}
                      />
                    </div>
                    <ShowImageModel imgLink={imgLink} />

                    <input
                      className="bg-primary-red text-white rounded-xl px-2"
                      type="button"
                      value="Delete"
                      onClick={() => {
                        // alert("hello")
                        // setImgLink('')

                        let newDocs = docs.filter((val, docsIndex) => {
                          // console.log("item", item);
                          // console.log("index", index);
                          // console.log("docs Index", docsIndex);

                          if (index === docsIndex) {
                            val.image = "";
                            val.document_name = "";
                          }

                          return val;
                        });
                        // console.log("updated docs", newDocs);

                        setDocs(newDocs);
                      }}
                    />
                  </div>
                </td>
                <td className="border-l border-blue-600">
                  <input
                    type="text"
                    className="ml-2 outline-none overflow-x-auto w-[90%]"
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Documents;
